import React from "react";

const SvgIzquierda: React.FC<{ className?: string; width?: number; height?: number }> = ({
  className,
  width = 20,
  height = 15,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className ?? ""}
    viewBox="0 0 40 30"
    width={width}
    height={height}
  >
    {/* Línea principal */}
    <line
      x1="65"
      y1="15"
      x2="15"
      y2="15"
      stroke="#1E3A8A"
      strokeWidth="6"
      strokeLinecap="round"
    />

    {/* Punta de flecha */}
    <polyline
      points="25,7 10,15 25,23"
      fill="none"
      stroke="#1E3A8A"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Animación suave */}
    <animate
      attributeName="opacity"
      values="0.4;1;0.4"
      dur="2s"
      repeatCount="indefinite"
    />
  </svg>
);

export default SvgIzquierda;
